// refresh cached csrf token and captchas
// see https://verbb.io/craft-plugins/formie/docs/v1/template-guides/cached-forms

// Wait until the DOM is ready
document.addEventListener('DOMContentLoaded', (event) => {
  let $forms = document.querySelectorAll('.fui-form');

  $forms.forEach(($form) => {
    // Fetch the form we want to deal with
    // Find the CSRF token hidden input, so we can replace it
    let $csrfInput = $form.querySelector('input[name="CRAFT_CSRF_TOKEN"]');
    let $formHandle = $form.querySelector('input[name="handle"]');
    // console.log(`refersh token of form ID : #${$form.id}, name: ${$formHandle.value}`);

    window.setTimeout(() => {
      // Fetch the new token for the form and replace the CSRF input with our new one
      fetch(`/actions/formie/forms/refresh-tokens?form=${$formHandle.value}`)
        .then(result => { return result.json(); })
        .then(result => { $csrfInput.outerHTML = result.csrf.input; });
    }, 2000)
  });
});